import React from 'react';
import SectionCard from './section-card';
import ToggleSwitch from './toggle-switch';

const ToggleRow = ({
  title,
  description,
  enabled,
  onChange,
  tone,
  disabled,
  trailing,
  children,
}) => (
  <SectionCard>
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 flex-1">
        <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">
          {title}
        </h3>
        {description ? (
          <p className="mt-1 max-w-xl text-sm text-slate-500 dark:text-slate-400">
            {description}
          </p>
        ) : null}
      </div>
      <div className="flex items-center gap-3">
        {trailing}
        <ToggleSwitch
          checked={enabled}
          onChange={onChange}
          tone={tone}
          disabled={disabled}
        />
      </div>
    </div>
    {children ? <div className="mt-5">{children}</div> : null}
  </SectionCard>
);

export default ToggleRow;
